import _ from "lodash";
import { getSettingValue } from "Utils/ConfigurationUtils";
import { CODE_EDITOR_PROGRAMMING_LANGUAGES } from "@toddle-edu/common-utils";

export const MARKDOWN = "MARKDOWN";
export const persistLanguagePreferenceSetting =
  "CodeEditorLastSelectedLanguage";

export const themeJson = {
  base: "vs",
  inherit: true,
  rules: [
    {
      background: "F5F5F5",
      token: "",
    },
  ],
  colors: {
    "editor.background": "#F5F5F5",
    "editor.selectionBackground": "#B0B0FF",
    "editor.lineHighlightBackground": "#00000026",
  },
};

export const getMarkdownToJsonCode = markdownCode => {
  const pattern = /```(\w+)?\n([\s\S]*?)```/;
  const match = markdownCode.match(pattern);

  if (match) {
    const languageCode = _.nth(match, 1);
    const language = _.get(
      _.find(CODE_EDITOR_PROGRAMMING_LANGUAGES, { key: languageCode }),
      "key"
    );
    const code = _.trim(_.nth(match, 2));
    return {
      language,
      code,
    };
  }

  let language = "javascript";

  // if user had selected any language in the past, set it as default
  try {
    const settingValue = getSettingValue({
      name: persistLanguagePreferenceSetting,
      readFromUserAndOrgLevel: true,
    });

    if (!_.isEmpty(settingValue)) {
      language = settingValue;
    }
  } catch (e) {}

  return {
    language,
    code: "",
  };
};

export const getJsonToMarkdownCode = codeEditorObj => {
  const { code = "", language = "javascript" } = codeEditorObj || {};
  const languageCode = _.get(
    _.find(CODE_EDITOR_PROGRAMMING_LANGUAGES, { key: language }),
    "key"
  );
  if (code) return `\`\`\`${languageCode}\n${code}\n\`\`\``;
  else return "";
};

export const getInitialCodeEditorObj = ({ input, inputFormat }) => {
  if (inputFormat === MARKDOWN) {
    return getMarkdownToJsonCode(input);
  }
  return input;
};

export const getFormattedCode = ({ codeEditorObj, outputFormat }) => {
  if (outputFormat === MARKDOWN) {
    return getJsonToMarkdownCode(codeEditorObj);
  }
  return codeEditorObj;
};
